module.exports = __webpack_public_path__ + "images/Immunizations_SS_1046242816_f66312e.jpg";